import { useState } from "react";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function SwitchDeviceDialog({
  isOpen,
  onOpenChange,
  deviceName,
  transferDeviceOptions,
  onConfirm,
  loading,
}) {
  const [selectedDevice, setSelectedDevice] = useState("");
  const [note, setNote] = useState("");

  const handleClose = () => {
    setSelectedDevice("");
    setNote("");
    onOpenChange(false);
  };

  const handleConfirm = async () => {
    await onConfirm?.({ targetDeviceId: selectedDevice, note });
    setSelectedDevice("");
    setNote("");
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-xl">
        <DialogHeader>
          <DialogTitle>Switch Device</DialogTitle>
          <DialogDescription>
            {`Configure device switch for ${deviceName || "selected device"}.`}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="target-device">Select Device</Label>
            <Select value={selectedDevice} onValueChange={setSelectedDevice}>
              <SelectTrigger id="target-device" className="w-full h-10">
                <SelectValue placeholder="Choose target device" />
              </SelectTrigger>
              <SelectContent>
                {transferDeviceOptions.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label htmlFor="switch-note">Input Value</Label>
            <Input
              id="switch-note"
              placeholder="Enter note or reference"
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
          </div>
        </div>

        <div className="mt-5 flex justify-end gap-2">
          <Button type="button" variant="outline" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            type="button"
            onClick={handleConfirm}
            disabled={!selectedDevice || loading}
          >
            {loading ? "Switching..." : "Confirm"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
